import { root } from '../../../../../../../store/constants';

export const MAX_NUMBER_LENGTH = 9;

export const ERROR_MESSAGE_MAX_VALUE = root.Messages.getText('error.cardNumber.maxValue');
export const ERROR_MESSAGE_NOT_NUMBER = root.Messages.getText('error.cardNumber.notNumber');
export const ERROR_MESSAGE_TOO_LONG = root.Messages.getText('error.cardNumber.tooLong');
